import Vue from 'vue'
import Router from 'vue-router'

//路由懒加载
const index = r => require.ensure([], () => r(require('@/pages/home')), 'index')
const marketingList = r => require.ensure([], () => r(require('@/pages/marketing/marketingList')), 'marketingList')
const marketingDetail = r => require.ensure([], () => r(require('@/pages/marketing/marketingDetail')), 'marketingDetail')
const newsList = r => require.ensure([], () => r(require('@/pages/news/newsList')), 'newsList')
const newsClassify = r => require.ensure([], () => r(require('@/pages/news/newsClassify')), 'newsClassify')
const newsDetail = r => require.ensure([], () => r(require('@/pages/news/newsDetail')), 'newsDetail')
const exhibition = r => require.ensure([], () => r(require('@/pages/exhibition')), 'exhibition')
const productDetail = r => require.ensure([], () => r(require('@/pages/product/productDetail')), 'productDetail')
const productDetail2 = r => require.ensure([], () => r(require('@/pages/product/productDetail2')), 'productDetail2')
const productList = r => require.ensure([], () => r(require('@/pages/product/productList')), 'productList')
const productSub = r => require.ensure([], () => r(require('@/pages/product/productSub')), 'productSub')
const support = r => require.ensure([], () => r(require('@/pages/support')), 'support')
const manual = r => require.ensure([], () => r(require('@/pages/support/manual')), 'manual')
const download = r => require.ensure([], () => r(require('@/pages/support/download')), 'download')
const ecatalog = r => require.ensure([], () => r(require('@/pages/support/ecatalog')), 'ecatalog')
const datasheet = r => require.ensure([], () => r(require('@/pages/support/datasheet')), 'datasheet')
const qanda = r => require.ensure([], () => r(require('@/pages/support/qanda')), 'qanda')
const company = r => require.ensure([], () => r(require('@/pages/company')), 'company')
const pagesList = r => require.ensure([], () => r(require('@/pages/pages_list')), 'pagesList')
const search = r => require.ensure([], () => r(require('@/pages/search')), 'search')
const router_match = r => require.ensure([], () => r(require('@/pages/router_match')), 'router_match')
const error = r => require.ensure([], () => r(require('@/pages/error/error')), 'error')

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
    //首页
    {
			path: '/',
			name: 'index',
			component: index
		},
    //marketingList首页
		{
			path: '/Marketing.html',
			name: 'marketingList',
			component: marketingList,
		},
    //marketing详情页
    {
      path: '/:name/Marketing-:id(\\d+)',
      name:'marketingDetail',
      component:marketingDetail
    },
    //news新闻首页
    {
      path: '/news.html',
      name:'newsList',
      component:newsList
    },
    //news新闻列表页
    {
      path: '/news-:name',
      name:'newsClassify',
      component:newsClassify
    },
    //news新闻详情页
    {
      path: '/new-:id(\\d+)',
      name:'newsDetail',
      component:newsDetail
    },
		{
			path: '/exhibition',
			name: 'exhibition',
			component: exhibition
		},
    //产品首页
    {
      path: '/product.html',
      name:'productList',
      component:productList
    },
    //产品列表页
    {
      path: '/product-:name',
      name:'productSub',
      component:productSub
    },
    //产品详情页
    {
    	path: '/product1-:name',
    	name: 'productDetail',
    	component: productDetail,
    },
	//产品详情页
	{
		path: '/products/:name-:id(\\d+).html',
		name: 'productDetail2',
		component: productDetail2,
	},
    //支持页面
    {
      path: '/support.html',
      name: 'support',
      component: support,
    },
    {
      path: '/manual/:name?',
      name: 'manual',
      component: manual,
    },
    {
      path: '/datasheet/:name?',
      name: 'datasheet',
      component: datasheet,
    },
    {
      path: '/e-catalog',
      name: 'ecatalog',
      component: ecatalog,
    },
    {
      path: '/download',
      name: 'download',
      component: download,
    },
    {
      path: '/q&a',
      name: 'qanda',
      component: qanda,
    },
    {
      path: '/company-:name',
      name: 'company',
      component: company,
    },
    //自定义单页
    {
      path: '/page-:name',
      name: 'pagesList',
      component: pagesList,
    },
    //搜索页面
    {
      path: '/search/:keyword?',
      name: 'search',
      component: search,
    },
    //万能路由
    {
      path: '/:name',
      name:'router_match',
      component:router_match,
    },
    // 匹配所有路由，跳转404页面
    {
      path: '*',
      name:'error',
      component:error
    }
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js